document.addEventListener('DOMContentLoaded', ()=>{
    let drawer = document.getElementById('productInformationDrawer')
    let overlay = document.querySelector('#productInformationDrawer + .product-information-drawer__overlay')

    let btns = document.querySelectorAll('.product-information__link')
    btns.forEach(btn => {
        btn.addEventListener('click', ()=> {
            if (!drawer || !overlay) return
            document.querySelector('body').classList.add('locked')
            drawer.classList.add('is-active')
            overlay.classList.add('is-active')
            let block_name = btn.getAttribute('data-id')
            let block = document.querySelector(`#productInformationDrawer div[data-id="${block_name}"]`)
            if (block) block.scrollIntoView({block: "start", behavior: "smooth"})
        })
    })

    let close = document.querySelector('.product-information-drawer__close')

    if (close) {
        close.addEventListener('click', ()=>{
            document.querySelector('body').classList.remove('locked')
            document.getElementById('productInformationDrawer').classList.remove('is-active')
            if (overlay) overlay.classList.remove('is-active')
        })
    }

    if (overlay && close) {
        overlay.addEventListener('click', ()=>{
            close.click();
        })
    }
})